<template>
  <div style="height: 100%;" class="candidate opportunities-map">
    <v-progress-linear
      indeterminate
      v-show="loading"
      :color="themes.candidate.light.primary"
      class="ma-0 loading-indicator"
      size="70"
      :height="5"
    />
    <OpportunityMap
      @update:bounds="updateBounds"
      @update:center="updateCenter"
      @apply="$emit('apply', $event)"
      :markers="markers"
      :loading="loading"
      height="100%"
      width="100%"
      use-query-params
      sticky
    />
  </div>
</template>

<script>
// Components
import OpportunityMap from '@/components/maps/OpportunityMap'

// Helpers
import { mapState } from 'vuex'
import _ from 'lodash'

// Mixins
import { CachedArray } from '@/mixins/CachedArray.js'
import { managedQueryParameters } from '@/mixins/managedQueryParameters.js'

export default {
  mixins: [CachedArray, managedQueryParameters],

  components: { OpportunityMap },

  computed: {
    ...mapState('candidate/opportunityLocations', {
      loading: 'loading',
      opportunityLocations: 'all',
    }),

    markers() {
      const locations = JSON.parse(JSON.stringify(this.cachedArray))

      return locations
        .filter(l => this.opportunityLocations.some(store => store.id === l.id))
        .sort((l1, l2) => {
          const i1 = this.opportunityLocations.findIndex(store => store.id === l1.id)
          const i2 = this.opportunityLocations.findIndex(store => store.id === l2.id)
          return i1 - i2
        })
    },
  },

  watch: {
    opportunityLocations: function(newLocations) {
      this.pushToCachedArray(newLocations)
    },
  },

  methods: {
    updateCenter: _.debounce(function(center) {
      if (center && center.lat && center.lng) {
        this.updateQueryParameters({ center: [center.lat, center.lng] })
        this.$emit('update:center', { geoCenter: { latitude: center.lat, longitude: center.lng } })
      }
    }, 500),

    updateBounds: _.debounce(function(bounds) {
      const northEast = bounds.getNorthEast()
      const southWest = bounds.getSouthWest()
      if (bounds.isValid() && !northEast.equals(southWest)) {
        this.$emit('update:bounds', {
          northEast: { latitude: northEast.lat, longitude: northEast.lng },
          southWest: { latitude: southWest.lat, longitude: southWest.lng },
        })
      }
    }, 500),
  },
}
</script>

<style lang="scss">
.candidate.opportunities-map .loading-indicator {
  position: absolute;
  z-index: 1;

  .opportunities.map {
    top: 64px;
  }
}
</style>
